import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { routeMeta } from "../../seo";

export default function RouteSeo() {
  const { pathname } = useLocation();
  const m = routeMeta(pathname);
  // Retire les balises statiques (index.html / pré-rendu) remplacées par celles de React
  useEffect(() => { document.head.querySelectorAll("[data-rh]").forEach((e) => e.remove()); }, []);
  return (
    <Helmet prioritizeSeoTags>
      <title>{m.title}</title>
      <meta name="description" content={m.description} />
      <link rel="canonical" href={m.canonical} />
      {m.noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="Ouest Conciergerie" />
      <meta property="og:title" content={m.title} />
      <meta property="og:description" content={m.description} />
      <meta property="og:url" content={m.canonical} />
      <meta property="og:image" content={m.image} />
      <meta name="twitter:card" content="summary_large_image" />
      {m.jsonLd.map((j, i) => <script key={i} type="application/ld+json">{JSON.stringify(j)}</script>)}
    </Helmet>
  );
}
